import store from "../store";
import Constants from "../config/constants";
import { serviceGetTaxReviews } from "../services/TaxFiling.service";
import EventEmitter from "../libs/Events.utils";

export const FETCH_INIT = "FETCH_INIT_PROVISIONAL_TAX";
export const FETCHED = "FETCHED_PROVISIONAL_TAX";
export const FETCHED_FAIL = "FETCHED_FAIL_PROVISIONAL_TAX";
export const FETCHED_FILTER = "FETCHED_FILTER_PROVISIONAL_TAX";
// export const NEXT_PREQUESTS = 'NEXT_PREQUESTS';
// export const PREV_PREQUESTS = 'PREV_PREQUESTS';
export const FETCH_NEXT = "FETCH_NEXT_PROVISIONAL_TAX";
export const FILTER = "FILTER_PROVISIONAL_TAX";
export const RESET_FILTER = "RESET_FILTER_PROVISIONAL_TAX";
export const SET_SORTING = "SET_SORTING_PROVISIONAL_TAX";
export const SET_FILTER = "SET_FILTER_PROVISIONAL_TAX";
export const SET_PAGE = "SET_PAGE_PROVISIONAL_TAX";
export const CHANGE_PAGE = "CHANGE_PAGE_PROVISIONAL_TAX";
export const CHANGE_STATUS = "CHANGE_STATE_PROVISIONAL_TAX";
export const SET_SERVER_PAGE = "SET_SERVER_PAGE_PROVISIONAL_TAX";
export const CREATE_DATA = "CREATE_PROVISIONAL_TAX";
export const UPDATE_DATA = "UPDATE_PROVISIONAL_TAX";
export const DELETE_ITEM = "DELETE_PROVISIONAL_TAX";

export function actionFetchProvisionalTaxList(index = 1, sorting = {}, filter = {}) {
  const request = serviceGetTaxReviews({
    index,
    row: sorting.row,
    order: sorting.order,
    ...filter,
  });
  return (dispatch) => {
    dispatch({ type: FETCH_INIT, payload: null });
    request.then((data) => {
      dispatch({ type: SET_FILTER, payload: filter });
      dispatch({ type: SET_SORTING, payload: sorting });
      if (!data.error) {
        dispatch({ type: FETCHED, payload: { data: data.data, page: index } });
        dispatch({ type: SET_SERVER_PAGE, payload: index });
        if (index == 1) {
          dispatch({ type: CHANGE_PAGE, payload: index - 1 });
        }
      } else {
        dispatch({ type: FETCHED_FAIL, payload: null });
      }
    });
  };
}

export function actionChangePageProvisionalTax(page) {
  return (dispatch) => {
    dispatch({ type: CHANGE_PAGE, payload: page });
  };
}

export function actionFilterProvisionalTaxList(value) {
  const request = null; ////serviceFetchProviderRequests(value);
  return (dispatch) => {
    dispatch({ type: FETCH_INIT, payload: null });
    request.then((data) => {
      dispatch({ type: FILTER, payload: data });
      dispatch({ type: FETCHED, payload: null }); //dispatch function
    });
  };
}

export function actionChangeStatusProvisionalTaxList(id, status) {
  return (dispatch) => {
    dispatch({ type: CHANGE_STATUS, payload: { id, status } });
  };
}

export function actionResetFilterProvisionalTaxList() {
  return {
    type: RESET_FILTER,
    payload: null,
  };
}

export function actionSetPageProvisionalTaxList(page) {
  const stateData = store.getState().provisional_tax;
  const currentPage = stateData.currentPage;
  const totalLength = stateData.all.length;
  const sortingData = stateData.sorting_data;
  const query = stateData.query;
  const queryData = stateData.query_data;
  const serverPage = stateData.serverPage;

  if (totalLength <= (page + 1) * Constants.DEFAULT_PAGE_VALUE) {
    store.dispatch(
      actionFetchProvisionalTaxList(serverPage + 1, sortingData, {
        query,
        query_data: queryData,
      })
    );
  }

  console.log(currentPage, totalLength);
  return {
    type: CHANGE_PAGE,
    payload: page,
  };
}
